export type Bonus = {
  id: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Pastry Troubleshooting & Problem-Solving Manual',
    description:
      'A practical visual guide to identify common pastry failures, understand the likely cause and apply the correct fix.',
  },
  {
    id: '2',
    title: 'Pastry Instructor Cueing & Error Correction Handbook',
    description:
      'Ready-to-use instructor cues, student corrections and practical teaching language for real pastry classes.',
  },
  {
    id: '3',
    title: 'Pastry Class Planning & Sequencing System',
    description:
      'Class structures, station organization, timing systems, demonstrations and student rotations ready to use.',
  },
  {
    id: '4',
    title: 'Pastry Student Assessment & Progress Tracking System',
    description:
      'Skill rubrics, observation sheets, practical assessments and progress tools for student development.',
  },
  {
    id: '5',
    title: '100 Pastry Teaching Challenges, Practice Tasks & Skill Drills',
    description:
      'Ready-to-use student activities for precision, technique, shaping, lamination, piping, baking, decorating and troubleshooting.',
  },
]
